import React, { useState, useEffect } from 'react';
import 'src/app/popup.scss';

import { userRolePermissionService } from 'src/app/services';
import { permissionActions } from 'src/app/redux/actions';
import { useDispatch, useSelector } from 'react-redux';

import { OntologyEnum } from 'src/enums/ontology.enum';

import { reduxRootTypes } from 'src/types';
import UserRightsForm from 'src/app/components/Forms/UserRightsForm/userRightsForm';
import {
  UserRolePermissionDataType,
  UserRolePermissionResultType,
} from 'src/types/services/userRolePermission-service.type';
import { groupBy } from 'lodash';
import { Item, EventPropsType, deleteConfirmTitles } from './userRights.config';

import { displaySuccessStatusMessage } from 'src/app/helpers/status.helper';
import { checkPermissionList } from 'src/app/helpers/permissions.helper';
import { PermissionEnum } from 'src/enums/permission.enum';
import useSearch from 'src/app/hooks/useSearch';
import CustomTable from 'src/app/components/CustomTable/CustomTable';
import { useTranslation } from 'react-i18next';

import Input from 'antd/es/input';

import Popover from 'antd/es/popover';
import Typography from 'antd/es/typography';
import Popconfirm from 'antd/es/popconfirm';

import Button from 'antd/es/button/button';

const { Search } = Input;

const UserRightsTab: React.FC<EventPropsType> = (props: EventPropsType) => {
  const { t } = useTranslation();

  const defaultUserRightsData = {
    id: 0,
    userRoleId: '',
    permissionId: [],
  };

  const [currentStep, setCurrentStep] = useState<number>(0);

  const [addUserRights, setAddUserRightsModal] = useState<boolean>(false);
  const [modalInEditMode, setModalInEditMode] = useState<boolean>(false);

  const [dataForUserRights, setDataForUserRights] = useState<any[]>([]);
  const [userRightsAllData, setUserRightsAllData] = useState<UserRolePermissionResultType[]>([]);
  const [userRightsDataInForm, setUserRightsDataInForm] = useState<UserRolePermissionDataType>(defaultUserRightsData);

  const [choosenRow, setChoosenRow] = useState<any>();
  // const [searchValue, setSearchValue] = useState<string>('');
  const { searchValue, onSearch } = useSearch();
  const [disabledElement, setDisabledElement] = useState<boolean>(false);

  const dispatch = useDispatch();
  const { ontologies } = useSelector((state: reduxRootTypes.RootStateType) => state.ontologyState);
  const { userrolepermissions } = useSelector((state: reduxRootTypes.RootStateType) => state.userRolePermissionState);
  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);

  const { userRoles } = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const user = useSelector((state: reduxRootTypes.RootStateType) => state.userState);

  useEffect(() => {
    const adminId = ontologies.find((item) => item.abbreviation === 'Admin' || item.abbreviation === 'SİSYÖN')?.id;

    const getId = userRoles.find((obj) => obj.id === adminId)?.id;

    if (getId === undefined) {
      setDisabledElement(true);
    }
  }, []);

  const lastVisitedKey = userRightsDataInForm.userRoleId || '';

  const onClickAddPlayerType = () => {
    if (modalInEditMode) {
      setUserRightsDataInForm(defaultUserRightsData);
    }
    setAddUserRightsModal(true);
    setModalInEditMode(false);
  };
  const [list, setList] = useState<{ userRoleId: string; permissions: number[] }[]>([]);

  const getPermissionList = async () => {
    try {
      // const userPermissionData = await userRolePermissionService.lookupUserRolePermission({ blockSpinner: true });
      if (searchValue.length > 0) {
        const searchResults = ontologies.filter(
          (item) =>
            Number(item.ontologyType) === OntologyEnum.User_Role &&
            item.abbreviation?.toLowerCase() !== 'Root'.toLowerCase() &&
            item.abbreviation?.toLowerCase().includes(searchValue.toLowerCase()),
        );

        const filterUserRolePermission: UserRolePermissionResultType[] = [];
        userrolepermissions.forEach((obj) => {
          searchResults.forEach((o) => {
            if (obj.userRoleId === o.id) {
              filterUserRolePermission.push(obj);
            }
          });
        });
        setUserRightsAllData(filterUserRolePermission);
      } else {
        setUserRightsAllData(userrolepermissions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPermissionList();
  }, [userrolepermissions, searchValue]);

  useEffect(() => {
    const groupByCategory = groupBy(userRightsAllData, 'userRoleId');

    setList(
      Object.keys(groupByCategory).map((userRoleId) => {
        return { userRoleId, permissions: groupByCategory[userRoleId].map((element) => element.permissionId) };
      }),
    );
  }, [userRightsAllData]);

  useEffect(() => {
    const clearData: Item[] = [];

    list.forEach((item) => {
      const userRoleName = ontologies
        .filter((obj) => Number(obj.ontologyType) === OntologyEnum.User_Role && obj.abbreviation !== 'Root')
        .find((c) => c.id === item.userRoleId)?.abbreviation;

      if (userRoleName) {
        // Eğer userRoleName "Root" yüzünden undefined olursa, ekleme yapma
        clearData.push({
          id: item.userRoleId,
          userRoleId: userRoleName,
          permissionId: item.permissions,
        });
      }
    });

    setDataForUserRights(clearData);
  }, [list, ontologies]);

  // useEffect(() => {
  //   setUserRightsAllData(userrolepermissions);
  // }, [userrolepermissions]);

  // const debouncedSearch = React.useRef(
  //   debounce(async (criteria) => {
  //     setSearchValue(criteria);
  //   }, 300),
  // ).current;

  // useEffect(() => {
  //   return () => {
  //     debouncedSearch.cancel();
  //   };
  // }, [debouncedSearch]);

  // const onSearch = (input: string | React.ChangeEvent<HTMLInputElement>) => {
  //   if (typeof input === 'string') {
  //     debouncedSearch(input);
  //   } else {
  //     debouncedSearch(input.target.value);
  //   }
  // };

  const cancel = () => {};
  const onClickShow = (record: Partial<Item> & { id: React.Key }) => {
    setAddUserRightsModal(true);
    setModalInEditMode(true);
  };
  const edit = (record: Partial<Item> & { id: React.Key }) => {
    const item = userRightsAllData.filter((o) => o.userRoleId === record.id);
    if (item) {
      onClickShow(record);
      setChoosenRow(record);
      setUserRightsDataInForm({ ...record, userRoleId: record.id });

      const mapUserRolePermission = item?.map((el: any) => ({
        id: el.id,
        userRoleId: ontologies.find((e) => e.id === el.userRoleId)?.abbreviation,
        permissionId: el,
      }));

      // setUserRightsAllData(mapUserRolePermission);
      // setUserRightsDataInForm({ ...item });
      // setModalInEditMode(true);
      // setAddUserRightsModal(true);
    }
  };

  const deleteUserRight = async (deletedItem: Item) => {
    try {
      await userRolePermissionService.deleteUserRolePermission({ id: deletedItem.id });

      if (deletedItem.id === userRightsDataInForm.userRoleId) {
        setUserRightsDataInForm(defaultUserRightsData);
        // TODO açık olan popup sayfasının kapanması için değişkeni ekle.
      }
      // setUserRightsAllData(userRightsAllData.filter((item) => item.id !== deletedItem.id));
      if (deletedItem.userRoleId) {
        dispatch(permissionActions.userRolePermissionDeleted(deletedItem.id));
        displaySuccessStatusMessage(t('success.deleted'));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: t('administration.userRights.userRoleName'),
      dataIndex: 'userRoleId',
      width: '20%',
    },
    {
      title: t('general.operation.operation'),
      dataIndex: 'operation',
      width: '8%',
      render: (_: any, record: Item) => {
        return (
          <div>
            <Popover content={<div>{t('general.operation.edit')}</div>} trigger="hover">
              <Typography.Link
                onClick={() => edit(record)}
                disabled={
                  (disabledElement && checkPermissionList(PermissionEnum.UserRightsUpdate)) ||
                  (record.userRoleId === 'Admin' && userState.userName !== 'Admin')
                }
              >
                <img className="edit-icon" src="/assets/editIcon.png" alt="edit" />
              </Typography.Link>
            </Popover>
            <Popover content={<div>{t('general.operation.delete')}</div>} trigger="hover">
              <Popconfirm
                placement="bottom"
                title={deleteConfirmTitles().title}
                okText={deleteConfirmTitles().okText}
                cancelText={deleteConfirmTitles().cancelText}
                icon=""
                onCancel={() => deleteUserRight(record)}
                disabled={
                  (disabledElement && checkPermissionList(PermissionEnum.UserRightsDelete)) ||
                  (record.userRoleId === 'Admin' && userState.userName !== 'Admin')
                }
              >
                <img
                  className="delete-icon"
                  src="/assets/deleteIcon.png"
                  alt="delete"
                  aria-disabled={
                    checkPermissionList(PermissionEnum.UserRightsDelete) ||
                    (record.userRoleId === 'Admin' && userState.userName !== 'Admin')
                  }
                />
              </Popconfirm>
            </Popover>
          </div>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    return {
      ...col,
      onCell: (record: Item) => ({
        record,
        inputType: col.dataIndex === 'type' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
      }),
    };
  });

  return (
    <>
      <div className="database-main-container">
        <div className="database-container">
          <div className="database-add-button-container">
            <Button
              className="database-add-button"
              onClick={onClickAddPlayerType}
              disabled={disabledElement && checkPermissionList(PermissionEnum.UserRightsCreate)}
            >
              <div className="database-add-button-inner-container">
                <p className="database-add-button-text">{t('administration.userRights.addUserRight')}</p>
              </div>
            </Button>
            <Search
              placeholder={t('general.search') || ''}
              allowClear
              onSearch={onSearch}
              onChange={onSearch}
              className="database-search-box"
            />
          </div>
          {/* <Table
            scroll={{ x: '100vh', y: '62vh' }}
            bordered
            dataSource={dataForUserRights.filter((obj) => obj.userRoleId !== 'Root')}
            columns={mergedColumns}
            rowClassName={(record) => (record.id === lastVisitedKey.toString() ? 'last-visited-row' : '')}
            pagination={{
              pageSize: 10,
              pageSizeOptions: [10],
              showSizeChanger: true,
              showTotal: () => `Total ${dataForUserRights.length} items`,
              onChange: cancel,
            }}
          /> */}
          <CustomTable
            dataSource={dataForUserRights.filter((obj) => obj.userRoleId !== 'Root')}
            columns={mergedColumns}
            rowClassName={(record) => (record.id === lastVisitedKey.toString() ? 'last-visited-row' : '')}
            scroll={{ x: 0, y: 'calc(100vh - 350px)' }}
          />
        </div>
      </div>

      {addUserRights && userRightsDataInForm && (
        <UserRightsForm
          setEditModal={modalInEditMode}
          userRightsForm={userRightsDataInForm}
          onClickOpen
          setOnClickOpen={setAddUserRightsModal}
        />
      )}
    </>
  );
};

export default UserRightsTab;
